import resources from "../../core/Localization/Localization";
import { partOfferTypes } from "../../variables/partOfferTypes";
import { partOfferStatuses, partOfferStatusOptions } from "../../variables/partOfferStatusOptions";
import { getDateString } from "../../utils/getDateString";

export const offersColumns = () => [
    {
        field: "id",
        headerName: resources.partOffers.datagrid.id,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "partname",
        headerName: resources.partOffers.datagrid.partname,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "make",
        headerName: resources.partOffers.datagrid.make,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "model",
        headerName: resources.partOffers.datagrid.model,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "price",
        headerName: resources.partOffers.datagrid.price,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "type",
        headerName: resources.partOffers.datagrid.type,
        filter: true,
        sort: true,
        filterType: "dropdown",
        filterOptions: {
            names: Object.values(partOfferTypes),
            renderValue: (v) => resources.partOffers.types[v],
        },
        customFilterListOptions: { render: (v) => `${resources.partOffers.datagrid.type}: ${resources.partOffers.types[v]}` },
        flex: 1
    },
    {
        field: "status",
        headerName: resources.partOffers.datagrid.status,
        filter: true,
        sort: true,
        filterType: "dropdown",
        filterOptions: {
            names: Object.values(partOfferStatusOptions),
            renderValue: (v) => {
                let val = Object.values(partOfferStatuses()).find((x) => x.value === v);
                return val.headerName;
            },
        },
        customFilterListOptions: {
            render: (v) => {
                let val = Object.values(partOfferStatuses()).find((x) => x.value === v);
                return `${resources.partOffers.datagrid.status}: ${val.headerName}`;
            },
        },
        flex: 1
    },
    {
        field: "username",
        headerName: resources.partOffers.datagrid.username,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "createdAt",
        headerName: resources.partRequests.datagrid.created,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1,
        valueGetter: (value) => getDateString(value)
    }
];
